/**
 * @file Normalizes an Http error into fields, translated message and flags, from either the `res.rest` or `res.serverError` body.
 * A response with no body gets a generic translated message.
 */
import Logger from "../Logger/Logger";
import Translator from "../Translation/Translator";
import Formatter from "../Localization/Formatter";

export interface NormalizedErrorResponseInterface {
  message: string;
  fields: string[];
  translatedMessage: string;
  isAuthenticationIssue: boolean;
  isValidationError: boolean;
  errorId: any;
  blockingCharge: any;
};

class ResponseNormalizer {

  public normalize(err): any {
    if (typeof err.response === "undefined") {
      Logger.log(err.message);
      if(err.message && document.getElementById('loader-text')) {
        var errorMessageBlock = document.createElement("div");
        errorMessageBlock?.classList.add("error-text-preloader");
        var errorMessageFirstBlock = document.createElement("span");
        var errorMessageSecondBlock = document.createElement("span");
        var errorMessageFirst = document.createTextNode(err.message);
        var errorMessageSecond= document.createTextNode('    Please reload page!');
        errorMessageFirstBlock.appendChild(errorMessageFirst);
        errorMessageSecondBlock.appendChild(errorMessageSecond);
        errorMessageBlock.appendChild(errorMessageFirstBlock);
        errorMessageBlock.appendChild(errorMessageSecondBlock);
        if (!document.getElementsByClassName('error-text-preloader')[0]) {
          document.getElementById('loader-text').appendChild(errorMessageBlock);
        }
      }

      err.message = err.message;
      err.fields = [];
      err.translatedMessage = Translator.trans("error-response-is-undefined");
      err.isAuthenticationIssue = false;
      err.isValidationError = false;
      err.errorId = null;
      err.blockingCharge = null;
      return err;
    }

    if (typeof err.response.data === "undefined") {
      Logger.log(err.message);
      err.fields = [];
      err.translatedMessage = Translator.trans("error-response-contains-no-message");
      err.isAuthenticationIssue = false;
      err.isValidationError = false;
      err.errorId = null;
      err.blockingCharge = null;
      return err;
    }

    Logger.log(err?.response?.data?.error?.defaultMessage);

    const errorFields = err?.response?.data?.error?.fields || err?.response?.data?.details?.fields || [];
    const counterpartyDisplayName = err?.response?.data?.error?.errorFieldCounterpartyDisplayName ||
      err?.response?.data?.details?.errorFieldCounterpartyDisplayName;
    err.message = err?.response?.data?.error?.defaultMessage;
    err.fields = errorFields;
    err.translatedMessage = err?.response?.data?.error?.id === "be_dynamic_error" ?
      err?.response?.data?.error?.defaultMessage
      :
      counterpartyDisplayName ? Translator.trans(err?.response?.data?.error?.id, {displayName: counterpartyDisplayName})
      :
      Translator.trans(err?.response?.data?.error?.id,
      {
        financialStartDate: Formatter.formatDate(err?.response?.data?.error?.financialStartDate),
        fieldName: errorFields[0] || '',
      });
    err.isAuthenticationIssue = err?.response?.status === 401;
    err.isValidationError = !!err?.response?.data?.error?.validationError ||
      (err?.response?.data?.details?.fields || []).length > 0;
    err.errorId = err?.response?.data?.error?.id;
    err.blockingCharge = err?.response?.data?.error?.blockingCharge;
    return err;
  }
}

export default new ResponseNormalizer();
